define('plugin/product/view/ProductCategoryItemView',['require','lib/view/LayoutView','lib/theme/ThemeSettings'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var ThemeSettings = require('lib/theme/ThemeSettings');

    /**
     * Product item view
     *
     * @class ProductItemView
     */
    return LayoutView.extend({

        getTemplate: function () {
            if (ThemeSettings.getInstance().getOption('display_item_mode') === 'list') {
                return '#product_category_item_view_list';
            }
            return '#product_category_item_view';
        },

        serializeData: function () {
            var products = this.model.get('products');
            var product_count = products ? products.length : 0;

            return _.extend(LayoutView.prototype.serializeData.apply(this, arguments), {
                product_count: product_count
            });
        }

    });

});
